import React from 'react';

export const Loader = ({ className, color = '#fff', width = 20, height = 20 }) => {
  return (
    <svg
      className={className}
      width={`${width}px`}
      height={`${height}px`}
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
    >
      <circle
        cx="50"
        cy="50"
        fill="none"
        stroke={color}
        strokeWidth="10"
        r="35"
        strokeDasharray="164.93361431346415 56.97787143782138"
        style={{ animationPlayState: 'running', animationDelay: '0s' }}
        transform="rotate(311.547 50 50)"
      >
        <animateTransform
          attributeName="transform"
          type="rotate"
          repeatCount="indefinite"
          dur="1s"
          values="0 50 50;360 50 50"
          keyTimes="0;1"
          style={{ animationPlayState: 'running', animationDelay: '0s' }}
        />
      </circle>
    </svg>
  );
};
